import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotActiveLicense = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 14,
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 10.6668V17.3335C20 19.3335 19 20.6668 16.6667 20.6668H11.3333C9 20.6668 8 19.3335 8 17.3335V10.6668C8 8.66683 9 7.3335 11.3333 7.3335H16.6667C19 7.3335 20 8.66683 20 10.6668Z",
			stroke: "#A0A0A0",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.668 9V10.3333C15.668 11.0667 16.268 11.6667 17.0013 11.6667H18.3346",
			stroke: "#A0A0A0",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.332 14.6665H13.9987",
			stroke: "#A0A0A0",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.332 17.3335H16.6654",
			stroke: "#A0A0A0",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNotActiveLicense;
